import { OverlayComponentUserParams } from "ag-grid-community";

export const overlayComponentParams: OverlayComponentUserParams = {
  loading: { overlayText: "Loading forms..." },
  noRows: { overlayText: "No forms found" },
  noMatchingRows: {
    overlayText: "No forms found",
  },
};
